import React, { Component } from 'react';
import Title from './Title';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


function preventDefault(event) {
  event.preventDefault();
}

class Status extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backColor: this.props.backColor,
      backColorHover: this.props.backColorHover,
      title: this.props.title,
      status: this.props.status,
      date: this.props.date
    }
  }

  render() {
    return (

      <Box
        sx={{
          width: '100%',
          height: 300,
          backgroundColor: this.state.backColor,
          '&:hover': {
            backgroundColor: this.state.backColorHover,
            opacity: [0.9, 0.8, 0.7],
          },
        }}
      >
        <h3 style={{ color: "white" }}>{this.state.title}</h3>
        <Typography variant="h2" component="div" gutterBottom color="white">
          <b>{this.state.status}</b>

        </Typography>
        <Typography variant="p" component="div" gutterBottom color="white">
          <p>{this.state.date}</p>
        </Typography>

      </Box>

    );
  }
}

export default Status;
